import Footer from "@/components/Footer";
import Header from "@/components/Header";
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useEffect, useState } from "react";
import { fetchPageContent, submitForm } from "@/api/apis";
import HTML_Renderer from "@/components/HTML_Renderer";

const Contact = () => {
  const [, setLocation] = useLocation();

  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchPageContent("contact").then((res) => {
      const sections = ["head"];
      const sectionsData: any = {};

      Object.keys(res.data.content).map((fieldKey) => {
        const fieldSection = sections.find((sec) => fieldKey.includes(sec));

        if (fieldSection) {
          sectionsData[fieldSection] = {
            ...(sectionsData[fieldSection] || {}),
            [fieldKey.replace(fieldSection + "_", "")]:
              res.data.content[fieldKey],
          };
        }
      });

      setContent(sectionsData);
    });
  }, []);

  ////////
  const [data, setData] = useState({
    full_name: "",
    email: "",
    inquiry_type: "",
    message: "",
    agree_contact: true,
  });

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Contact form submitted to contact@wearemusicnation.ae");

    submitForm("ContactSubmission", data)
      .then((res) => {
        setLocation("/thank-you-contact");
      })
      .catch((e) => {
        console.log("SOMETHING WENT WRONG", e);
      });
  };

  return (
    <div className="min-h-screen bg-musicBlack">
      <Header />

      <main className="pt-24">
        {/* ─── HERO ─────────────────────────────────────────────── */}
        <section className="relative pt-24 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="absolute inset-0" />
            <div className="absolute inset-0" />
           
          </div>

          {content?.head && (
            <div className="relative z-10 editorial-container">
              <div className="max-w-3xl">
                <h1 className="text-white font-serif text-4xl md:text-5xl font-bold mb-4">
                  {content.head.title}
                </h1>
                <HTML_Renderer
                  content={content.head.content}
                  className={"mb-12"}
                />
              </div>
            </div>
          )}
        </section>

        {/* ─── CONTACT FORM ─────────────────────────────────────── */}
        <section className=" bg-black">
          <div className="editorial-container">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              {/* form */}
              <div>
                <h2 className="text-white font-serif text-3xl font-bold mb-6">
                  Get in Touch
                </h2>
                <p className="font-sans text-musicGrey mb-8">
                  Fill out the form and our team will respond within 24 hours.
                </p>

                <form
                  name="contact"
                  data-netlify="true"
                  netlify-honeypot="bot-field"
                  onSubmit={handleFormSubmit}
                  className="space-y-6"
                >
                  <input type="hidden" name="form-name" value="contact" />
                  <input type="hidden" name="bot-field" />

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <Label
                        htmlFor="name"
                        className="text-musicWhite font-sans"
                      >
                        Full Name
                      </Label>
                      <Input
                        id="name"
                        name="name"
                        placeholder="Your name"
                        required
                        className="bg-musicBlack border-musicGrey/30 text-musicWhite focus:border-musicRed"
                        onChange={(e) =>
                          setData((d) => ({ ...d, full_name: e.target.value }))
                        }
                      />
                    </div>
                    <div className="space-y-2">
                      <Label
                        htmlFor="email"
                        className="text-musicWhite font-sans"
                      >
                        Email Address
                      </Label>
                      <Input
                        id="email"
                        name="email"
                        type="email"
                        required
                        placeholder="Your email"
                        className="bg-musicBlack border-musicGrey/30 text-musicWhite focus:border-musicRed"
                        onChange={(e) =>
                          setData((d) => ({ ...d, email: e.target.value }))
                        }
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <Label
                      htmlFor="inquiry"
                      className="text-musicWhite font-sans"
                    >
                      Inquiry Type
                    </Label>
                    <Select
                      name="inquiry"
                      onValueChange={(e) =>
                        setData((d) => ({ ...d, inquiry_type: e }))
                      }
                    >
                      <SelectTrigger className="bg-musicBlack border-musicGrey/30 text-musicWhite focus:border-musicRed">
                        <SelectValue placeholder="Select inquiry type" />
                      </SelectTrigger>
                      <SelectContent className="bg-musicBlack border-musicGrey/30 text-musicWhite">
                        <SelectItem value="creator">
                          Creator Registration
                        </SelectItem>
                        <SelectItem value="business">
                          Business Licensing
                        </SelectItem>
                        <SelectItem value="media">Media Inquiry</SelectItem>
                        <SelectItem value="claim">Report a Claim</SelectItem>
                        <SelectItem value="other">Other</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>

                  <div className="space-y-2">
                    <Label
                      htmlFor="message"
                      className="text-musicWhite font-sans"
                    >
                      Message
                    </Label>
                    <Textarea
                      id="message"
                      name="message"
                      required
                      placeholder="How can we help you?"
                      className="bg-musicBlack border-musicGrey/30 text-musicWhite focus:border-musicRed min-h-[150px]"
                      onChange={(e) =>
                        setData((d) => ({ ...d, message: e.target.value }))
                      }
                    />
                  </div>

                  <Button type="submit" className="cta-button w-full md:w-auto">
                    Submit Inquiry
                  </Button>
                </form>
              </div>

              {/* contact info - simplified */}
              <div>
                <h2 className="text-white font-serif text-3xl font-bold mb-6">
                  Direct Contact
                </h2>
                <div className="space-y-8">
                  <div>
                    <h3 className="font-serif text-xl font-medium text-musicRed mb-3">
                      Contact Information
                    </h3>
                    <p className="font-sans text-musicGrey mb-2">
                      <strong className="text-musicWhite">Email:</strong>{" "}
                      contact@wearemusicnation.ae
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
